import axios from "axios";
import { API_BASE_URL1 } from "../../Services/baseApiUrl";
import axiosInstance from "../../../Hooks/axoisInstance";

const getToken = () => {
    return localStorage.getItem("token");
  };

  //console.log(getToken1,"gettoken1")
  export const getAllmobileApk = async () => {
    try {
      const response = await axiosInstance.get(API_BASE_URL1 +`APK/GetApkFileNames`,
          {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };

  export const getAllmobileApkById = async (startDate, endDate) => {
    try {
      const response = await axiosInstance.get(
        API_BASE_URL1 +
          `/APK/GetApkFileNames`,
          {
            headers: {
              Authorization: `Bearer ${getToken()}`
            }
          },
      );
      return response;
    } catch (error) {
      throw error;
    }
  };